module.exports = __webpack_public_path__ + "nrecoveries_icon.svg";